import eCommerceStoreMutations from '@/state/eCommerceStore/eCommerceStoreMutations'
import eCommerceStoreActions from '@/state/eCommerceStore/eCommerceStoreActions'
import geteCommerceStoreDefaultState from '@/state/eCommerceStore/eCommerceStoreDefaultState'

let state = geteCommerceStoreDefaultState()

export const eCommerceStore = {
  namespaced: true,
  state,
  getters: {
    isValidPaymentMethod: state => {
      let {
        isCardNumberComplete,
        isCVCComplete,
        isExpDateComplete
      } = state.paymentDetails
      if (isCardNumberComplete && isCVCComplete && isExpDateComplete) {
        return true
      }
      return false
    },
    hasCustomDomain: state => {
      return !!state.shopDetails.customDomain
    }
  },
  mutations: eCommerceStoreMutations,
  actions: eCommerceStoreActions
}
